<template>
  <div>
    <v-container class="py-8" fluid>
      <v-row justify="center">
        <v-col cols="12" md="8">
          <h1 class="text-h5 mb-6  text-primary font-weight-bold">About Us</h1>

          <p class="mb-4 text-secondary">
            Welcome to <strong>Quizzr</strong> — your go-to platform for
            hosting and playing engaging quizzes!
          </p>

          <p class="mb-4">
            Whether you're a teacher, trainer, event host, or just a quiz
            enthusiast, our platform makes it simple and powerful to create and
            manage interactive quizzes.
          </p>

          <v-row class="mt-6" dense>
            <v-col cols="12" md="6">
              <v-card elevation="2" class="pa-4 h-100">
                <h3 class="text-subtitle1 mb-2">🧑‍🏫 For Organizers</h3>
                <p>
                  Easily design custom quizzes, manage participants, and track
                  results. Perfect for schools, events, and corporate training.
                </p>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card elevation="2" class="pa-4 h-100">
                <h3 class="text-subtitle1 mb-2">🎮 For Participants</h3>
                <p>
                  Join quizzes from anywhere, compete in real-time, and track
                  your performance. Learn while having fun!
                </p>
              </v-card>
            </v-col>
          </v-row>

          <p class="mt-6">
            Our mission is to make learning and engagement fun, interactive, and
            accessible for everyone. Join us and take your quiz experience to
            the next level.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script></script>
